<!-- Footer Component -->
<script>
  import { Col, Row, Container, Input } from "sveltestrap";

  let email

  function encode(data) {
    return Object.keys(data)
            .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
            .join("&")
  }

  const subscribe = () => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": "contact",
        email
      })
    }).then(() => alert("Thank you for subscribing")).catch(error => alert(error))
  }
</script>

<!--START FOOTER-->
<footer class="footer">
  <Container>
    <Row>
      <Col lg="3" class="mt-4">
        <h4>ESTRADAS CONSTRUCTION</h4>
        <div class="text-muted mt-4">
          <ul class="list-unstyled footer-list">
            <li><a href={"#"}>Home</a></li>
            <li><a href={"#"}>About us</a></li>
            <li><a href={"#"}>Careers</a></li>
            <li><a href={"#"}>Contact us</a></li>
          </ul>
        </div>
      </Col>
      <Col lg="3" class="mt-4">
        <h4>Information</h4>
        <div class="text-muted mt-4">
          <ul class="list-unstyled footer-list">
            <li><a href={"#"}>Terms & Condition</a></li>
            <li><a href={"#"}>About us</a></li>
            <li><a href={"#"}>Jobs</a></li>
            <li><a href={"#"}>Bookmarks</a></li>
          </ul>
        </div>
      </Col>
      <Col lg="3" class="mt-4">
        <h4>Support</h4>
        <div class="text-muted mt-4">
          <ul class="list-unstyled footer-list">
            <li><a href={"#"}>FAQ</a></li>
            <li><a href={"#"}>Contact</a></li>
            <li><a href={"#"}>Disscusion</a></li>
          </ul>
        </div>
      </Col>
      <Col lg="3" class="mt-4">
        <h4>Subscribe</h4>
        <div class="text-muted mt-4">
          <p>
            For public project status and special offers.
          </p>
        </div>
        <form class="form subscribe" on:submit|preventDefault={subscribe} name="subscribe" data-netlify="true" netlify-honeypot="status">
          <Input
            name="email"
            id="email"
            type="email"
            class="form-control"
            placeholder="Your email*"
            bind:value={email}
            required
          />
          <a href={"#"} class="submit" on:click={subscribe}>
            <i class="pe-7s-paper-plane" />
          </a>
          <p style="display: none">
            <input name="status" />
          </p>
        </form>
      </Col>
    </Row>
  </Container>
</footer>
<!--END FOOTER-->

<!--START FOOTER ALTER-->
<div class="footer-alt">
  <Container>
    <Row>
      <Col lg="12">
        <div class="float-start pull-none ">
          <p class="copy-rights text-muted">
            {new Date().getFullYear()}
            © Estradas Construction
          </p>
        </div>
        <div class="float-end pull-none ">
          <img src="images/payment.png" alt="payment-img" height="36" />
        </div>
        <div class="clearfix" />
      </Col>
    </Row>
  </Container>
</div>
<!--START FOOTER ALTER-->
